import * as React from "react";
import { Link } from "@fluentui/react";
import { parseId } from "../../helpers/idHelper";
import { useAppAuthContext } from "../../hooks/useAppAuthContext";
import { azurePortalUrl } from "../../utils";

export interface AzureVnetLinkProps {
  vnetId: string;
}

export const AzureVnetLink = (
  { vnetId }: AzureVnetLinkProps,
): JSX.Element => {
  const { domainName } = useAppAuthContext();
  const vnet = decodeURIComponent(parseId(vnetId)?.resourceName || "");

  return (
    <Link
      // eslint-disable-next-line max-len
      href={`${azurePortalUrl}/#@${domainName}/resource${vnetId}/overview`}
      target="_blank"
    >
      {vnet}
    </Link>
  );
};
